import React, { useState, useContext, Fragment } from 'react';
import { Divider,Typography, Col, Button,Drawer,Input,Form, Row, DatePicker, Progress } from 'antd';
import './styles.css'
import {useForm, Controller, useFieldArray} from 'react-hook-form';
import { EditOutlined} from '@ant-design/icons';
import { AuthContext } from '../context/Auth';
import Axios from 'axios';
import { API_URL } from '../context/constants';
import moment from 'moment';
import app from '../utils/base';

import FileUploader from 'react-firebase-file-uploader'

const {Title}=Typography
const CardsRutas = ({inicioRuta,nombreRuta,imagen,finRuta,horaFin,recargar,setRecargar,horaInicio,id,paradas,inicioServicio}) => {
  const [edit, setEdit] = useState(false);
   // eslint-disable-next-line
  const [nombreImagen,guardarNombre]=useState("")
  // eslint-disable-next-line
  const [subiendo,guardarSubiendo]=useState(false);
  const [progreso,guardarProgreso]=useState(0);
  const [urlImagen,guardarUrlImagen]=useState('')
  const {handleSubmit,control}=useForm(
    {
      defaultValues:{
        paradas
      }
      
    }
  );
  const {token}=useContext(AuthContext);
  const  handleUploadStart = () =>{
    guardarSubiendo(true);
    guardarProgreso(0)
   } 
  const handleProgress = progress =>{
    guardarProgreso(progress)
  } 
  const handleUploadError = error => {
    guardarSubiendo(false);
    // console.error(error);
  };
    const handleUploadSuccess = filename => {
      guardarProgreso(100);
      guardarSubiendo(false);
      guardarNombre(filename);
      app
        .storage()
        .ref("images")
        .child(filename)
        .getDownloadURL()
        .then(url =>{
          guardarUrlImagen(url);
        } );
    };

  const {fields,append,remove}=useFieldArray(
    {
      control,
      name:"paradas"
    }
  )
  const onDelete=async()=>{
    await Axios.delete(`${API_URL}/rutas/${id}`,{
      headers:{
        token
      }
    });
    setEdit(false)
    setRecargar(recargar+1);
  }
  const onSubmit=async(data)=>{
  
    if(data.inicioServicio!==null)
    data.inicioServicio=data.inicioServicio.format('D-MM-YYYY');
    if(urlImagen!=='')
    data.imagen=urlImagen
      await Axios.patch(`${API_URL}/rutas/${id}`,{data},{
          headers:{
            token
          }
        }
      );
      setEdit(false)
      setRecargar(recargar+1);
  }
    return (
    <>
       <Col xs={23} sm={23} md={7} lg={7} >
           <div className="card">
               <div style={{display:'flex',justifyContent:'space-between'}}>
               <Typography.Title level={3}>
                    {nombreRuta}
            </Typography.Title>
            <Button style={{marginRight:'1px',backgroundColor:'#2B7BBC'}} type='link' onClick={()=>setEdit(true)} shape='circle' icon={<EditOutlined style={{color:'#fff'}}/>} />

               </div>
           
                <div className="dosColumnas">
                    <Typography.Paragraph>
                        Inicio:{inicioRuta} {horaInicio}
                    </Typography.Paragraph>
                    <Typography.Paragraph>
                        Fin:{finRuta} {horaFin}
                    </Typography.Paragraph>

                </div>
                <img alt="Imagen de la ruta"  className="imagenCard" src={imagen}/>
           </div>
            
       </Col>
       <Drawer
        title={`Editando la ruta`}
        width={720}
        onClose={()=>setEdit(false)}
        visible={edit}
        footer={
            <div
              style={{
                textAlign: 'right',
              }}
            >
              <Button style={{marginRight: 8}} type="primary" htmlType='submit' onClick={handleSubmit(onSubmit)}>
                  Actualizar
                </Button>
              <Button
                danger
                type='primary'
                onClick={()=>onDelete()}
                style={{ marginRight: 8 }}
              >
                Borrar
              </Button>
              <Button
                onClick={()=>setEdit(false)}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
             
            </div>
          }
       >
        <Form
            layout='vertical'
            size='middle'
    
        >
          <Row gutter={16}>
            <Col>
              <Form.Item label="Nombre Ruta">
              <Controller as={Input} defaultValue={nombreRuta} name="nombreRuta" control={control} />
              </Form.Item>
            
            </Col>
            <Col>
            <Form.Item label="Inicio de Servicio">
              
              <Controller as={<DatePicker format="D-MM-YYYY"/>} 
              defaultValue={(inicioServicio===undefined||inicioServicio===null)?null:moment(inicioServicio,'D-MM-YYYY') } name="inicioServicio" control={control} />
              </Form.Item>
            </Col>
          </Row>
          
            <Row gutter={16}>
            <Col>
                <Form.Item label="Inicio de Ruta">
                    <Controller defaultValue={inicioRuta} as={Input} name="inicioRuta" control={control} />
                </Form.Item>
            </Col>
            <Col>
                <Form.Item label="Hora de inicio">
                    <Controller defaultValue={horaInicio} as={<Input type="time"/>} name="horaInicio" control={control} />
                </Form.Item>
            </Col>
            </Row>
            <Row gutter={16}>
            <Col>
              <Form.Item label="Fin de Ruta">
                <Controller defaultValue={finRuta} as={Input} name="finRuta" control={control} />
              </Form.Item>
            </Col>
            <Col>
            <Form.Item label="Hora de fin">
                <Controller defaultValue={horaFin} as={<Input type="time"/>} name="horaFin" control={control} />
              </Form.Item>
            </Col>
            </Row>
            <Divider/>
              <Title style={{marginTop:20,fontWeight:400}} level={4}  >
              Cambiar Imagen
            </Title>
                <FileUploader
                accept="image/*"
                name="imagenRuta"
                randomizeFilename
                storageRef={app.storage().ref("images") }
                onUploadStart={handleUploadStart}
                onUploadError={handleUploadError}
                onUploadSuccess={handleUploadSuccess}
                onProgress={handleProgress}
              />
              {progreso!==0&&
                <Progress size="small" width={30} type="circle" percent={progreso}/>
              }
            <Divider/>
            <Row align='middle' gutter={20}>
              <Col xs={16} sm={16} md={16} lg={16}>
            {
              fields.map(
               (item,index)=>{
                  return (
                    <Fragment>
                      <Row gutter={30}>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Form.Item label={`Nombre de la Parada ${index+1}`}>
                        <Controller defaultValue={item.parada} as={<Input />} name={`paradas[${index}].parada`} control={control} />
                        </Form.Item>
                      </Col>
                      <Col xs={12} sm={12} md={12} lg={12}> 
                        <Form.Item label={`Hora de la Parada ${index+1}`}>
                        <Controller defaultValue={item.horaParada} as={<Input type="time"/>} name={`paradas[${index}].horaParada`} control={control} />
                        </Form.Item>
                      </Col>
                      
                    </Row>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}> 
                        <Button onClick={() => remove(index)} type='danger'>Borra Parada</Button>
                      </Col>
                    </Row>
                    </Fragment>
                    
                  )
              }
              )
            }
              </Col>
              <Col>
                <Button onClick={() => {
                          append({ parada:'parada', horaParada:'0:00' });
                        }}>
                      Añadir Parada
                    </Button>
              </Col>
            </Row>
            
        </Form>
       </Drawer>
    </>
     );
}
 
export default CardsRutas;